import type React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';
import {
  getShareFeedbackMessageIds,
  SHARE_FEEDBACK_URL_TRACKING,
} from '@xing-com/crate-social-common-share';
import { SingleSizeIllustrationHeroCheckReady } from '@xing-com/illustrations';

import { Styled } from './share-feedback.styles';

export type ShareFeedbackType = {
  onCancel: () => void;
  targetType: string;
  redirectUrl: string;
};

export const ShareFeedback: React.FC<ShareFeedbackType> = ({
  onCancel,
  targetType,
  redirectUrl,
}) => {
  const { message, button } = getShareFeedbackMessageIds(targetType);

  return (
    <Styled.Layout>
      <Styled.Headline size="xxlarge">
        <FormattedMessage
          values={{
            item: <FormattedMessage id="SHARE_FEEDBACK_POST_LABEL" />,
          }}
          id={message}
        />
      </Styled.Headline>
      <SingleSizeIllustrationHeroCheckReady />
      <Styled.ButtonBar>
        <Styled.TextButton size="medium" onClick={onCancel}>
          <FormattedMessage id="SHARE_CANCEL_BUTTON" />
        </Styled.TextButton>
        <Button
          variant="primary"
          href={redirectUrl + SHARE_FEEDBACK_URL_TRACKING}
        >
          <FormattedMessage id={button} />
        </Button>
      </Styled.ButtonBar>
    </Styled.Layout>
  );
};
